module.exports = __webpack_public_path__ + "static/media/YB5F18_4.bd3cd316.jpg";